import React, { useRef, useEffect } from "react";
import uuganbayar from "../assets/uuganbayar.jpg";
import borhuu from "../assets/borhuu.jpg";
import hatnaa from "../assets/hatnaa.jpg";
import erdeneOchir from "../assets/9.png";
import erdenetsetseg from "../assets/erdenetsetseg.jpg";
import khuchitbaatar from "../assets/8.png";
import magsarjalam from "../assets/10.png";
import uugantsetseg from "../assets/11.png";

function Team() {
  const scrollContainerRef = useRef(null);
  const isUserInteracting = useRef(false); // Track user interaction

  const teamMembers = [
    {
      img: uuganbayar,
      name: "Түвдэндансрангийн Ууганбаяр",
      title: "/Хууль зүйн ухааны магистр, Докторант/",
      experience: [
        "Нэгдсэн эмнэлгийн Хуулийн зөвлөх",
        "ИТХ-ын Ажлын албаны мэргэжилтэн, хуулийн зөвлөх",
        '"Зорчигч тээвэр гурав" ОНӨААТҮГ-ын Ахлах хуулийн зөвлөх, Захиргаа удирдлагын хэлтсийн дарга',
        "Соёлын яамны Хууль, эрх зүйн хэлтсийн мэргэжилтэн, Ахлах мэргэжилтэн",
        "Хуульч, өмгөөлөгч",
      ],
    },
    {
      img: borhuu,
      name: "Баясгалангийн Борхүү",
      title: "/Хууль зүйн ухааны магистр/",
      experience: [
        "2011-2015 он “Даффинг” ХХК-ийн хуулийн зөвлөх",
        "2015 оноос Хуульч, өмгөөлөгч",
      ],
    },
    {
      img: hatnaa,
      name: "Равдандоржийн Хатансайхан",
      title: "/Хууль зүйн ухааны магистр/",
      experience: [
        "Эрдэм шинжилгээний ахлах ажилтан",
        "МУИС-ХЗС багш",
        "Хуульч, өмгөөлөгч",
      ],
    },
    {
      img: erdeneOchir,
      name: "Бат-Очирын Эрдэнэ-Очир",
      title: "/Хууль зүйн ухааны магистр/",
      experience: [
        "“Есөн Од” ХХК-д Хуулийн зөвлөх",
        "Татварын ерөнхий газарт татварын улсын байцаагч, хуульч",
        "Хуульч, өмгөөлөгч",
      ],
    },
    {
      img: erdenetsetseg,
      name: "Жаргалсайханы Эрдэнэцэцэг",
      title: "Ахлах Хуульч",
      experience: [
        "2013-2016 Дүүргийн иргэний хэргийн анхан шатны 2 дугаар шүүхийн шүүх хуралдааны нарийн бичгийн дарга",
        "2016-2019 Баянгол дүүргийн Иргэний хэргийн анхан шатны шүүхийн шүүгчийн туслах",
        "2019-2024 “Монхангай групп” ХХК-ийн Хуульч, Ахлах",
      ],
    },
    {
      img: khuchitbaatar,
      name: "Б.ХҮЧИТБААТАР",
      title: "Хуульч, эрх зүйч",
      experience: [],
    },
    {
      img: magsarjalam,
      name: "Л.МАГСАРЖАЛАМ",
      title: "Аудитор, мэргэшсэн нягтлан бодогч",
      experience: [],
    },
    {
      img: uugantsetseg,
      name: "О.УУГАНЦЭЦЭГ",
      title: "Сэтгэл зүйч, шинжээч",
      experience: [],
    },
  ];

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;

    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      isUserInteracting.current = true; // Pause auto-scroll
      scrollContainer.classList.add("active");
      startX = e.pageX || e.touches[0].pageX - scrollContainer.offsetLeft;
      scrollLeft = scrollContainer.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
      isUserInteracting.current = false; // Resume auto-scroll
      scrollContainer.classList.remove("active");
    };

    const handleMouseUp = () => {
      isDown = false;
      isUserInteracting.current = false; // Resume auto-scroll
      scrollContainer.classList.remove("active");
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = (e.pageX || e.touches[0].pageX) - scrollContainer.offsetLeft;
      const walk = (x - startX) * 1.5; // Adjust scroll speed
      scrollContainer.scrollLeft = scrollLeft - walk;
    };

    scrollContainer.addEventListener("mousedown", handleMouseDown);
    scrollContainer.addEventListener("mouseleave", handleMouseLeave);
    scrollContainer.addEventListener("mouseup", handleMouseUp);
    scrollContainer.addEventListener("mousemove", handleMouseMove);
    scrollContainer.addEventListener("touchstart", handleMouseDown);
    scrollContainer.addEventListener("touchend", handleMouseUp);
    scrollContainer.addEventListener("touchmove", handleMouseMove);

    return () => {
      scrollContainer.removeEventListener("mousedown", handleMouseDown);
      scrollContainer.removeEventListener("mouseleave", handleMouseLeave);
      scrollContainer.removeEventListener("mouseup", handleMouseUp);
      scrollContainer.removeEventListener("mousemove", handleMouseMove);
      scrollContainer.removeEventListener("touchstart", handleMouseDown);
      scrollContainer.removeEventListener("touchend", handleMouseUp);
      scrollContainer.removeEventListener("touchmove", handleMouseMove);
    };
  }, []);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;

    const autoScroll = () => {
      if (scrollContainer && !isUserInteracting.current) {
        scrollContainer.scrollLeft += 1; // Adjust speed
        if (scrollContainer.scrollLeft >= scrollContainer.scrollWidth / 2) {
          scrollContainer.scrollLeft = 0; // Reset to the start for infinite scrolling
        }
      }
    };

    const interval = setInterval(autoScroll, 30); // Adjust speed by changing the interval time
    return () => clearInterval(interval); // Cleanup on component unmount
  }, []);

  return (
    <section id="team">
      <h2
        style={{
          textAlign: "center",
          fontSize: "2rem",
          fontWeight: "bold",
          marginBottom: "30px",
          color: "#333",
          textTransform: "uppercase", // Make the title unique
          borderBottom: "2px solid #ffd700", // Add a unique underline
          display: "inline-block",
          paddingBottom: "10px",
        }}
      >
        Манай хамт олон
      </h2>
      <div
        ref={scrollContainerRef}
        className="team-scroll-container"
        style={{
          display: "flex",
          overflow: "hidden", // Hide scrollbar
          gap: "20px",
          padding: "10px",
          cursor: "grab",
          userSelect: "none", // Prevent text selection
        }}
      >
        {[...teamMembers, ...teamMembers].map((member, index) => (
          <div
            key={index}
            style={{
              textAlign: "center",
              flex: "0 0 auto",
              width: "150px",
            }}
          >
            <img
              src={member.img}
              alt={member.name}
              style={{ maxWidth: "100%", borderRadius: "50%" }}
            />
            <p>
              <strong>{member.name}</strong>
            </p>
            <p>{member.title}</p>
            {member.experience.length > 0 && (
              <>
                <p style={{ color: "black", textAlign: "left" }}>
                  Ажлын туршлага:
                </p>
                <ul style={{ color: "black", textAlign: "left" }}>
                  {member.experience.map((exp, i) => (
                    <li key={i}>{exp}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Team;